"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useAsyncHookResponse(value, loading, error) {
    var _a = react_1.useState(createNewPromise()), promise = _a[0], setPromise = _a[1];
    var _b = react_1.useState(false), complete = _b[0], setComplete = _b[1];
    react_1.useEffect(updatePromise, [loading]);
    function updatePromise() {
        if (loading && !complete)
            return;
        if (!loading && complete)
            return;
        if (loading && complete)
            setNewPromise();
        if (!loading && !complete)
            completePromise();
    }
    function completePromise() {
        if (error) {
            setComplete(true);
            promise.reject(error);
        }
        else {
            setComplete(true);
            promise.resolve(value);
        }
    }
    function setNewPromise() {
        setComplete(false);
        setPromise(createNewPromise());
    }
    function createNewPromise() {
        var resolve = function () { return null; };
        var reject = function () { return null; };
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        return { raw: promise, resolve: resolve, reject: reject };
    }
    return [value, loading, error, promise.raw];
}
exports.useAsyncHookResponse = useAsyncHookResponse;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWFzeW5jLWhvb2stcmVzcG9uc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlLWFzeW5jLWhvb2stcmVzcG9uc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBMEM7QUFTMUMsU0FBZ0Isb0JBQW9CLENBQUksS0FBZSxFQUFFLE9BQWdCLEVBQUUsS0FBbUI7SUFDcEYsSUFBQSx5Q0FBMEUsRUFBekUsZUFBTyxFQUFFLGtCQUFnRSxDQUFDO0lBQzNFLElBQUEsNEJBQXlDLEVBQXhDLGdCQUFRLEVBQUUsbUJBQThCLENBQUM7SUFFaEQsaUJBQVMsQ0FBQyxhQUFhLEVBQUUsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBRXBDLFNBQVMsYUFBYTtRQUNsQixJQUFJLE9BQU8sSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFPO1FBQ2pDLElBQUksQ0FBQyxPQUFPLElBQUksUUFBUTtZQUFFLE9BQU87UUFFakMsSUFBSSxPQUFPLElBQUksUUFBUTtZQUFFLGFBQWEsRUFBRSxDQUFDO1FBQ3pDLElBQUksQ0FBQyxPQUFPLElBQUksQ0FBQyxRQUFRO1lBQUUsZUFBZSxFQUFFLENBQUM7SUFDakQsQ0FBQztJQUVELFNBQVMsZUFBZTtRQUNwQixJQUFJLEtBQUssRUFBRTtZQUNQLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUNsQixPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ3pCO2FBQU07WUFDSCxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDbEIsT0FBTyxDQUFDLE9BQU8sQ0FBQyxLQUFVLENBQUMsQ0FBQztTQUMvQjtJQUNMLENBQUM7SUFFRCxTQUFTLGFBQWE7UUFDbEIsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ25CLFVBQVUsQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQUVELFNBQVMsZ0JBQWdCO1FBQ3JCLElBQUksT0FBTyxHQUF1QixjQUFNLE9BQUEsSUFBSSxFQUFKLENBQUksQ0FBQztRQUM3QyxJQUFJLE1BQU0sR0FBMkIsY0FBTSxPQUFBLElBQUksRUFBSixDQUFJLENBQUM7UUFDaEQsSUFBTSxPQUFPLEdBQUcsSUFBSSxPQUFPLENBQUksVUFBQyxHQUFHLEVBQUUsR0FBRztZQUNwQyxPQUFPLEdBQUcsR0FBRyxDQUFDO1lBQ2QsTUFBTSxHQUFHLEdBQUcsQ0FBQztRQUNqQixDQUFDLENBQUMsQ0FBQztRQUVILE9BQU8sRUFBQyxHQUFHLEVBQUUsT0FBTyxFQUFFLE9BQU8sU0FBQSxFQUFFLE1BQU0sUUFBQSxFQUFDLENBQUM7SUFDM0MsQ0FBQztJQUVELE9BQU8sQ0FBQyxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7QUFDaEQsQ0FBQztBQXpDRCxvREF5Q0MifQ==